export const LSTT_LIST_INITING             = 'LSTT_LIST_INITING'
export const LSTT_LIST_REQUESTING          = 'LSTT_LIST_REQUESTING'
export const LSTT_LIST_SUCCESS             = 'LSTT_LIST_SUCCESS'
export const LSTT_LIST_ERROR               = 'LSTT_LIST_ERROR'   

export const LSTT_EXPORT_XLS_REQUESTING     = 'LSTT_EXPORT_XLS_REQUESTING'
export const LSTT_EXPORT_XLS_SUCCESS        = 'LSTT_EXPORT_XLS_SUCCESS'
export const LSTT_EXPORT_XLS_ERROR          = 'LSTT_EXPORT_XLS_ERROR'

export const LSTT_REMOVE_REQUESTING        = 'LSTT_REMOVE_REQUESTING'
export const LSTT_REMOVE_SUCCESS           = 'LSTT_REMOVE_SUCCESS'
export const LSTT_REMOVE_ERROR             = 'LSTT_REMOVE_ERROR' 

export const LSTT_LIST_API                 = '/api/v1/congno/lichsuthanhtoan_list_by_store'   
export const LSTT_REMOVE_API               = '/api/v1/congno/lichsuthanhtoan_remove_by_id' 
export const LSTT_EXPORT_API               = '/api/v1/congno/lichsuthanhtoan_export_list_by_store'    


// WEBPACK FOOTER //
// ./src/views/LichSuThanhToan/constants.js